import { render, staticRenderFns } from "./bookingBoard.vue?vue&type=template&id=766e6c29&scoped=true"
import script from "./bookingBoard.vue?vue&type=script&lang=js"
export * from "./bookingBoard.vue?vue&type=script&lang=js"
import style0 from "./bookingBoard.vue?vue&type=style&index=0&id=766e6c29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e6c29",
  null
  
)

export default component.exports